import script from "./MailSecurityPopupView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MailSecurityPopupView.vue?vue&type=script&lang=ts&setup=true"

import "./MailSecurityPopupView.vue?vue&type=style&index=0&id=81f14ec6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81f14ec6"]])

export default __exports__